/*
	piano_loaddemos.js
*/

document.addEventListener('DOMContentLoaded', () => {
	loadDemosMain();
});






function loadDemosMain() {
	const tracks = [
	{ id: 0, title: 'Trailer (piano & synth)',  composer: 'Michael Künstle' },
	{ id: 1, title: 'Solitude (piano only)',     composer: 'Thomas Stolz' },
	{ id: 2, title: 'Snowforms (in context)',    composer: 'Matteo Pagamici' },
	{ id: 3, title: 'Everglow (in context)',     composer: 'Matteo Pagamici' },
	{ id: 4, title: 'Saltface (synth)',          composer: 'Cédric Ziegler' },
	{ id: 5, title: 'Dunes (piano only)',        composer: 'Daniel Dettwiler' },
];

const gridMain = document.querySelector('.audio-main-grid'); // adjust selector to match your container

gridMain.innerHTML = tracks.map(({ id, title, composer }) => `
	<div class="audio-demo" id="audio-demo-${id}">
		<div class="audio-logo" id="audio-logo-${id}">
			<div class="audio-logo-image" id="audio-logo-image-${id}"></div>
		</div>
		<div class="audio-player">
			<div class="audio-title">
			  <div class="audio-title-track">${title}</div>
			  <div class="audio-title-composer">${composer}</div>
			</div>
			<div class="audio-stats">
			  <div class="audio-info">
			    <div class="audio-time">
			      <span id="audio-current-duration-${id}">0:00</span> / <span id="audio-max-duration-${id}"></span>
			    </div>
			  </div>
			  <div class="audio-line" id="audio-line-${id}">
			    <div class="audio-progress audio-progress-remaining" id="audio-progress-remaining-${id}"></div>
			    <div class="audio-progress audio-progress-done" id="audio-progress-done-${id}"></div>
			  </div>
			</div>
		</div>
	</div>
`).join('');
}



function loadDemosUI() {
	const gridLeft = document.querySelector('.audio-ui-grid-left');
	const gridRight = document.querySelector('.audio-ui-grid-right');
	for(i=0;i<3;i++) {
		gridLeft.innerHTML += `
		<div class="audio-demo-mini audio-demo-mini-round" id="audio-demo-mini-round-${i+100}">
			<div class="audio-logo-mini audio-logo-mini-round" id="audio-logo-mini-round-${i+100}" data-id="${i}">
				<div class="audio-logo-image" id="audio-logo-image-${i+100}"></div>
			</div>
			<div class="audio-player audio-player-mini">
				<div class="audio-title audio-title-mini">
					<div class="audio-title-track" id="audio-title-track-${i+100}"></div>
				</div>
			</div>
		</div>
	`;
	}
	for(i=3;i<6;i++) {
		gridRight.innerHTML += `
		<div class="audio-demo-mini audio-demo-mini-round" id="audio-demo-mini-round-${i+100}">
			<div class="audio-logo-mini audio-logo-mini-round" id="audio-logo-mini-round-${i+100}" data-id="${i}">
				<div class="audio-logo-image" id="audio-logo-image-${i+100}"></div>
			</div>
			<div class="audio-player audio-player-mini">
				<div class="audio-title audio-title-mini">
					<div class="audio-title-track" id="audio-title-track-${i+100}"></div>
				</div>
			</div>
		</div>
	`;
	}
}

function loadDemosMini() {
   const tracksMini = [
	{ id: 10, category: 'BASS',      title: 'Deep Horn' },
	{ id: 11, category: 'PAD',       title: 'Cyan Shape' },
	{ id: 12, category: 'GRANULAR',  title: 'Sensory Deprivation' },
	{ id: 13, category: 'PAD DRY',   title: 'Plucky Organ' },
	{ id: 14, category: 'LEAD',      title: 'Far Dark' },
	{ id: 15, category: 'ARP',       title: 'Sand Dunes' },
	{ id: 16, category: 'BASS',      title: 'Cinematic Masterpiece' },
	{ id: 17, category: 'PAD',       title: 'Eternal Spheres' },
	{ id: 18, category: 'PLUCK',     title: 'Lead Pluck' },
	{ id: 19, category: 'PULSE',     title: 'Deconstructing' },
	{ id: 20, category: 'PAD BASIC', title: 'Anachronism' },
	{ id: 21, category: 'ARP',       title: 'Desert Sand' },
	{ id: 22, category: 'ARP BASS',  title: 'Cinematic Alternative' },
	{ id: 23, category: 'PAD',       title: 'Cinematic Wide' },
	{ id: 24, category: 'SEQ',       title: 'Train Surfing' },
	];

	const tracksSnapshots = [
	{ id: 30, category: 'BASS',      title: 'Deep Horn' },
	{ id: 31, category: 'PAD',       title: 'Cyan Shape' },
	{ id: 32, category: 'GRANULAR',  title: 'Sensory Deprivation' },
	{ id: 33, category: 'PAD DRY',   title: 'Plucky Organ' },
	{ id: 34, category: 'LEAD',      title: 'Far Dark' },
	{ id: 35, category: 'ARP',       title: 'Sand Dunes' },
	];

	const gridMini = document.querySelector('.audio-mini-grid');
	//const gridSnapshots = document.querySelector('.audio-snapshots-grid');

	gridMini.innerHTML = tracksMini.map(({ id, category, title }) => `
		<div class="audio-demo-mini audio-demo-mini-round" id="audio-demo-mini-round-${id}">
			<div class="audio-logo-mini audio-logo-mini-round" id="audio-logo-mini-round-${id}">
				<div class="audio-logo-image" id="audio-logo-image-${id}"></div>
			</div>
			<div class="audio-player audio-player-mini">
				<div class="audio-title audio-title-mini">
					<div class="audio-title-track audio-title-track-mini">${category}<br/>${title}</div>
				</div>
			</div>
		</div>
	`).join('');

	/*gridSnapshots.innerHTML = tracksSnapshots.map(({ id, category, title }) => `
		<div class="audio-demo-snapshots audio-demo-mini-round" id="audio-demo-mini-round-${id}">
			<div class="audio-logo-mini audio-logo-mini-round" id="audio-logo-mini-round-${id}">
				<div class="audio-logo-image" id="audio-logo-image-${id}"></div>
			</div>
			<div class="audio-player audio-player-mini">
				<div class="audio-title audio-title-mini">
					<div class="audio-title-track">${category}<br/>${title}</div>
				</div>
			</div>
		</div>
	`).join('');*/
}